import TransferModal from './TransferModal';
export default TransferModal;
//# sourceMappingURL=index.js.map
